module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: [_vm.$style.root]
  }, [_c('div', {
    staticClass: "box-widget",
    class: _vm.classNames
  }, [_c('div', {
    staticClass: "box-widget-head"
  }, [_vm._t("head"), (_vm.icon) ? _c('div', {
    staticClass: "box-widget-icon"
  }, [_c('icon', {
    attrs: {
      "name": _vm.icon,
      "scale": _vm.iconSizeScale
    }
  })], 1) : _vm._e(), (_vm.badge) ? [_c('div', {
    staticClass: "box-widget-badge"
  }, [_c('icon', {
    attrs: {
      "name": _vm.badgeIcon,
      "scale": "0.9"
    }
  })], 1)] : _vm._e()], 2), _c('div', {
    staticClass: "box-widget-content"
  }, [_vm._t("content")], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-139eab48"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/box-widget/BoxWidget.vue
// module id = 2006
// module chunks = 1